import { COLLECT_LOAD, COLLECT_RESERVE, GET_COLLECTION_HISTORY, GET_COLLECTIONS } from './collections.types';

/** Collections */

export const getCollections = (params, load) => {
  return {
    type: GET_COLLECTIONS,
    payload: { params, load }
  }
}
export const getCollectionHistory = (params) => {
  return {
    type: GET_COLLECTION_HISTORY,
    payload: { params }
  }
}
export const collectReserve = (carrierId, params) => {
  return {
    type: COLLECT_RESERVE,
    payload: { carrierId, params }
  }
}
export const collectLoad = (carrierId, params) => {
  return {
    type: COLLECT_LOAD,
    payload: { carrierId, params }
  }
}

/** End */

